import React, { useContext }  from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../auth/AuthContext";


const DashboardIndex = () => {
  const { setToken } = useContext(AuthContext);

  const handleLogout = () => {
    setToken(null); 
  };

  const navigate = useNavigate();
  const goToCompetitionPage = () => {
    navigate('/competition');
  };
  const goToDonorStatsPage = () => {
    navigate('/donor-stats');
  };
  const goToCreatedUserTrendsPage = () => {
    navigate('/created-user-trends');
  };
  const goToWeeklyUniqueUserTrendsPage = () => {
    navigate('/weekly-unique-user-trends');
  };
  const goToCountryTrendsPage = () => {
    navigate('/country-trends');
  };
  const goToEngagementByTypePage = () => {
    navigate('/engagement-by-type');
  };
  const goToNewUserReferralTrendsPage = () => {
    navigate('new-user-referral-trends');
  };
  const goToTotalLoginsByDayAndHourPage = () => {
    navigate('/total-logins-by-day-and-hour');
  };
  const goToPercentageEngagementPage = () => {
    navigate('/percentage-engagement');
  };
  const goToClaraUsagePage = () => {
    navigate('/clara-usage');
  };
  const goToEducatorDomainsPage = () => {
    navigate('/educator-domains');
  };
  const goToDemographicsDashboardPage = () => {
    navigate('/demographics-dashboard');
  };
  const goToClaraCategorizationIframeTestPage = () => {
    navigate('/clara-categorization-iframe-test');
  };
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="flex justify-between items-center p-4 border-b bg-white shadow-sm">
        <div><h1 className="text-xl font-bold text-gray-800">Dashboard</h1></div>
        <div>
          <button
            onClick={handleLogout}
            className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors"
          >
            Logout
          </button>
        </div>
      </div>

      <div className="p-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          <button
            onClick={goToCompetitionPage}
            className="bg-white p-8 rounded-lg shadow-md hover:shadow-lg transition-shadow border border-gray-200 hover:border-blue-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
          >
            <div className="text-center">
              <div className="text-lg font-semibold text-gray-800">Competition</div>
            </div>
          </button>

          <button
            onClick={goToDonorStatsPage}
            className="bg-white p-8 rounded-lg shadow-md hover:shadow-lg transition-shadow border border-gray-200 hover:border-blue-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
          >
            <div className="text-center">
              <div className="text-lg font-semibold text-gray-800">Donor Stats</div>
            </div>
          </button>

          <button
            onClick={goToCreatedUserTrendsPage}
            className="bg-white p-8 rounded-lg shadow-md hover:shadow-lg transition-shadow border border-gray-200 hover:border-blue-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
          >
            <div className="text-center">
              <div className="text-lg font-semibold text-gray-800">Created User Trends</div>
            </div>
          </button>

          <button
            onClick={goToWeeklyUniqueUserTrendsPage}
            className="bg-white p-8 rounded-lg shadow-md hover:shadow-lg transition-shadow border border-gray-200 hover:border-blue-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
          >
            <div className="text-center">
              <div className="text-lg font-semibold text-gray-800">Weekly Unique User Trends</div>
            </div>
          </button>

          <button
            onClick={goToCountryTrendsPage}
            className="bg-white p-8 rounded-lg shadow-md hover:shadow-lg transition-shadow border border-gray-200 hover:border-blue-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
          >
            <div className="text-center">
              <div className="text-lg font-semibold text-gray-800">Country Trends</div>
            </div>
          </button>

          <button
            onClick={goToEngagementByTypePage}
            className="bg-white p-8 rounded-lg shadow-md hover:shadow-lg transition-shadow border border-gray-200 hover:border-blue-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
          >
            <div className="text-center">
              <div className="text-lg font-semibold text-gray-800">Engagement By Type</div>
            </div>
          </button>

          <button
            onClick={goToNewUserReferralTrendsPage}
            className="bg-white p-8 rounded-lg shadow-md hover:shadow-lg transition-shadow border border-gray-200 hover:border-blue-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
          >
            <div className="text-center">
              <div className="text-lg font-semibold text-gray-800">New User Referral Trends</div>
            </div>
          </button>

          <button
            onClick={goToTotalLoginsByDayAndHourPage}
            className="bg-white p-8 rounded-lg shadow-md hover:shadow-lg transition-shadow border border-gray-200 hover:border-blue-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
          >
            <div className="text-center">
              <div className="text-lg font-semibold text-gray-800">Total Logins by Day and Hour</div>
            </div>
          </button>

          <button
            onClick={goToPercentageEngagementPage}
            className="bg-white p-8 rounded-lg shadow-md hover:shadow-lg transition-shadow border border-gray-200 hover:border-blue-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
          >
            <div className="text-center">
              <div className="text-lg font-semibold text-gray-800">Percentage Engagement</div>
            </div>
          </button>

          <button
            onClick={goToClaraUsagePage}
            className="bg-white p-8 rounded-lg shadow-md hover:shadow-lg transition-shadow border border-gray-200 hover:border-blue-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
          >
            <div className="text-center">
              <div className="text-lg font-semibold text-gray-800">Clara Usage</div>
            </div>
          </button>

          <button
            onClick={goToEducatorDomainsPage}
            className="bg-white p-8 rounded-lg shadow-md hover:shadow-lg transition-shadow border border-gray-200 hover:border-blue-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
          >
            <div className="text-center">
              <div className="text-lg font-semibold text-gray-800">Educator Domains</div>
            </div>
          </button>

          <button
            onClick={goToDemographicsDashboardPage}
            className="bg-white p-8 rounded-lg shadow-md hover:shadow-lg transition-shadow border border-gray-200 hover:border-blue-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
          >
            <div className="text-center">
              <div className="text-lg font-semibold text-gray-800">Demographics Dashboard</div>
            </div>
          </button>

          <button
            onClick={goToClaraCategorizationIframeTestPage}
            className="bg-white p-8 rounded-lg shadow-md hover:shadow-lg transition-shadow border border-gray-200 hover:border-blue-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
          >
            <div className="text-center">
              <div className="text-lg font-semibold text-gray-800">Clara Category Visualizations</div>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
};


export default DashboardIndex;